import Headroom from 'headroom.js'
import '../vendor/01_modernizr.min.js'
import '../vendor/02_owl.carousel.min.js'
import '../vendor/03_cssua.min.js'
import '../vendor/04_lazysizes.min.js'
import '../vendor/05_magnific-popup.min.js'
import $ from 'jQuery'

/**
 * @namespace Location
 * @author Location
 */

const Location = {

  /**
   * Initialize object
   * @function init
   * @memberof Location
   */

  init() {

    this.cache();
    this.events();
    this.initHeadroom();
    this.initProductTabs();
    this.initFormRedirect();
    this.initOwl();
    this.initLightbox();

  }, // init()

  /**
   * Cache reusable data
   * @function cache
   * @memberof Location
   */

  cache() {

    this.$doc = $(document);
    this.$win = $(window);
    this.$html = $('html');
    this.$body = $('body');
    this.$mainWrap = $('main');
    this.$header = $('.js-header');
    this.$mobileNav = $('.js-mobile-nav');
    this.$hamburger = $('.js-hamburger');

  }, // _cache()

  /**
   * Attach event listeners
   * @function _events
   * @memberof Location
   */

  events() {

    this.$doc.on(
        'click',
        '.js-hamburger',
        event => this.showMobileNav(event)
    );


    this.$doc.on(
        'click',
        '.js-share',
        event => this.openShareWindow(event)
    );

    $('.js-mobile-nav > ul > li.menu-item-has-children > a').click(function(e) {
      e.preventDefault();
      $(this).next('.sub-menu').slideToggle(400);
    });

    $('.js-accordion > dt > a').click(function(e) {
      e.preventDefault();
      var el = $(this);
      el.parent().next('dd').slideToggle(400);
      el.toggleClass('active');
    });

    $('#top').click(function (e) {
      e.preventDefault();
      $('html,body').animate({
        scrollTop: 0
      }, 700);
    });

  }, // _events()

  openShareWindow(event) {
    let link = $(event.currentTarget).attr('href');
    if (link.substr(0, 6) != 'mailto') {
        event.preventDefault();
        window.open(link, '', 'width=600, height=400');
    }
  },

  initProductTabs() {
    let hash = window.location.hash;
    jQuery('.product-page__tabbed-content ul.tabs li:first-child').addClass('current');
    jQuery('.product-page__tabbed-content .tabbed-content__sections .tab-content:first-child').addClass('current');
    if(hash) {
      var hash_stripped = hash.substring(1);
      jQuery('.product-page__tabbed-content ul.tabs li:first-child').removeClass('current');
      jQuery('.product-page__tabbed-content .tabbed-content__sections .tab-content:first-child').removeClass('current');
      jQuery('.tab-link[ title=' + hash_stripped + ']' ).addClass('current');
      jQuery( '.tab-content[ title=' + hash_stripped + ']' ).addClass( 'current' );
    }
    jQuery('.product-page__tabbed-content ul.tabs li').click(function(){
      var tab_id = jQuery(this).attr('data-tab');
      jQuery('.product-page__tabbed-content ul.tabs li').removeClass('current');
      jQuery('.product-page__tabbed-content .tab-content').removeClass('current');
      jQuery(this).addClass('current');
      jQuery("#"+tab_id).addClass('current');
    })
  },

  initFormRedirect() {
    if (jQuery("body").hasClass("page-id-5934")) {
      document.addEventListener( 'wpcf7mailsent', function( event ) {
        location = 'https://locationinc.com/thank-you-data-catalog-advertising/';
      }, false );
    }
  },

  initOwl() {
    $('.js-slider').owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      items: 1,
      navText: ['<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1203 544q0 13-10 23l-393 393 393 393q10 10 10 23t-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23z"/></svg>','<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1171 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"/></svg>']
    })
  },

  initLightbox() {
    $('.js-lightbox').magnificPopup({
      type:'image'
    });
  },

  initHeadroom() {
    let theHeader = document.querySelector('.js-header');
    let headroom = new Headroom(theHeader);
    headroom.init();
  },

  showMobileNav(event) {
    event.preventDefault();
    this.$mobileNav.toggleClass('is-active');
    this.$mobileNav.slideToggle(400);
    this.$hamburger.toggleClass('is-active');
    if ( this.$mobileNav.hasClass('is-active') ) {
      this.$hamburger.attr("aria-pressed", "true");
    } else {
      this.$hamburger.removeAttr("aria-pressed");
    }
  },
}; // Location

Location.init();
